import React from 'react';
import Icon from '../../../components/common/Icon/Icon';
import { PAYMENT_METHOD_OPTIONS } from '../checkout.constants';
import type { PaymentMethod } from '../checkout.types';
import { AppRequiredFieldTag } from '../../../components/common/appUi';
import styles from './CheckoutShared.module.css';

export interface PaymentMethodSelectorOption<TValue extends string = PaymentMethod> {
  value: TValue;
  label: string;
  icon?: string;
}

interface PaymentMethodSelectorProps<TValue extends string = PaymentMethod> {
  value: TValue | null;
  options?: Array<PaymentMethodSelectorOption<TValue>>;
  ariaLabel?: string;
  error?: string;
  disabled?: boolean;
  onChange: (method: TValue) => void;
}

const PaymentMethodSelector = <TValue extends string = PaymentMethod>({
  value,
  options = PAYMENT_METHOD_OPTIONS as Array<PaymentMethodSelectorOption<TValue>>,
  ariaLabel = 'Forma de pagamento',
  error,
  disabled = false,
  onChange,
}: PaymentMethodSelectorProps<TValue>) => (
  <div id="checkout-payment-method">
    {error && <AppRequiredFieldTag message={error} />}

    <div className={styles.paymentMethodGrid} role="radiogroup" aria-label={ariaLabel}>
      {options.map((option) => {
        const selected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`${styles.paymentMethodOption} ${selected ? styles.paymentMethodOptionSelected : ''}`}
            onClick={() => onChange(option.value)}
            disabled={disabled}
          >
            {option.icon && (
              <Icon name={option.icon} size={18} className={styles.paymentMethodIcon} />
            )}
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default PaymentMethodSelector;
